export const MAX_NOTIFICATIONS_SHOWN = 100
export const DISCUSSION_ASK_TO_ANSWER = 1
export const RESPONSE_ASK_TO_REPLY = 5
export const ACTION_API_URL = "/api/private/v1/notification/"
